// These are the rules by which the form input fields will be checked against.

import { HIGHLIGHT_REVIEW_VOTE_TYPES } from "../../config/constants/Constants";
import { formHasErrors, formHasValue, noValidation, setFormValues } from "./objectValidation";

const DESCRIPTION_MIN_LENGTH = 10; // Minimum length for description

/**
 * Criteria:
 * 1) Required
 */
const nameValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "name", true, "Required");
    }

    return setFormValues(row, "name", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be at least 5 characters long
 */
const descriptionValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "description", true, "Required");
    }

    // 2)
    if (value.length < DESCRIPTION_MIN_LENGTH) {
        return setFormValues(row, "description", true, `Must be at least ${DESCRIPTION_MIN_LENGTH} characters long`);
    }

    return setFormValues(row, "description", false, "");
};

/**
 * Criteria:
 * 1) Cannot be negative
 */
const _diversityWeightValidation = (prevConfig, row, value) => {
    // 1)
    if (isNaN(value) || value < 0) {
        return setFormValues(row, "_diversity_weight", true, "Must not be a negative number");
    }

    return setFormValues(row, "_diversity_weight", false, "");
};

/**
 * Criteria:
 * 1) Cannot be negative
 */
const _thresholdValidation = (prevConfig, row, value) => {
    // 1)
    if (isNaN(value) || value < 0 || value > 1) {
        return setFormValues(row, "_threshold", true, "Must be a number between 0 and 1");
    }

    return setFormValues(row, "_threshold", false, "");
};

/**
 * Criteria:
 * 1) Cannot be negative
 */
const _maxLengthSecValidation = (prevConfig, row, value) => {
    // 1)
    if (isNaN(value) || value < 0) {
        return setFormValues(row, "_max_length_secs", true, "Must be a positive number");
    }

    return setFormValues(row, "_max_length_secs", false, "");
};

/**
 * Criteria:
 * 1) Cannot be negative
 */
const _minTimestampSecValidation = (prevConfig, row, value) => {
    // 1)
    if (isNaN(value) || value < 0) {
        return setFormValues(row, "_min_timestamp_secs", true, "Must be a positive number");
    }

    return setFormValues(row, "_min_timestamp_secs", false, "");
};

// The main constant, directing to the specific validation function.
export const HIGHLIGHT_REQUEST_VALIDATION = {
    name: {
        check: nameValidation
    },
    description: {
        check: descriptionValidation
    },
    constraints: {
        check: noValidation
    },

    _diversity_weight: {
        check: _diversityWeightValidation
    },
    _threshold: {
        check: _thresholdValidation
    },
    _max_length_secs: {
        check: _maxLengthSecValidation
    },
    _min_timestamp_secs: {
        check: _minTimestampSecValidation
    }
};

export const IS_HIGHLIGHT_REQUEST_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "name") && formHasValue(obj, "description");
};

/**
 * Criteria:
 * 1) Must be YES, NO, or MAYBE
 */
const voteValidation = (prevConfig, row, value) => {
    // 2) Must be one of the allowed values
    if (!HIGHLIGHT_REVIEW_VOTE_TYPES.includes(value)) {
        return setFormValues(row, "vote", true, "Required");
    }

    return setFormValues(row, "vote", false, "");
};

// The main constant, directing to the specific validation function.
export const HIGHLIGHT_REVIEW_REQUEST_VALIDATION = {
    vote: {
        check: voteValidation
    },
    note: {
        check: noValidation
    }
};

export const IS_HIGHLIGHT_REVIEW_REQUEST_VALIDATION_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "vote");
};

// The main constant, directing to the specific validation function.
export const HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION = {
    highlight_request_ids: {
        check: noValidation
    }
};

export const IS_HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION_VALID = (obj) => {
    return true;
};
